<template>
  <b-modal
    title="Update Ad Account"
    ref="update-ad-account-modal"
    id="update-ad-account-modal"
    size="lg"
    hide-footer
  >
    <validation-observer ref="checkInfoRules" tag="form">
      <b-card class="m-0">
        <validation-provider
          #default="{ errors }"
          name="Title"
          rules="required"
        >
          <b-form-group label-for="title">
            Title<span class="text-danger"> *</span>
            <b-form-input
              id="title"
              class="form-control"
              :class="{
                'text-danger': adAccountInfo.title.length > titleSize,
                'border-danger': adAccountInfo.title.length > titleSize,
              }"
              v-model="adAccountInfo.title"
              maxLength="50"
            />

            <small
              class="textarea-counter-value float-right"
              :class="{
                'bg-danger': adAccountInfo.title.length > titleSize,
              }"
            >
              <span class="char-count">{{ adAccountInfo.title.length }}</span> /
              {{ titleSize }}
            </small>
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>

        <b-form-group label-for="description" label="Description">
          <b-form-textarea
            id="description"
            v-model="adAccountInfo.description"
            rows="3"
            maxLength="200"
          />
          <small
            class="textarea-counter-value float-right"
            :class="{
              'bg-danger': adAccountInfo.description.length > descriptionSize,
            }"
          >
            <span class="char-count">{{
              adAccountInfo.description.length
            }}</span>
            / {{ descriptionSize }}
          </small>
        </b-form-group>

        <validation-provider
          #default="{ errors }"
          name="Creative Groups"
          rules="required"
        >
          <b-form-group label-for="timezone">
            Timezone<span class="text-danger"> *</span>
            <v-select
              id="timezone"
              v-model="adAccountInfo.timezone"
              :options="timezoneOptions"
              :reduce="(option) => option.value"
              label="text"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>

        <validation-provider
          #default="{ errors }"
          name="Creative Groups"
          rules="required"
        >
          <b-form-group label-for="currency">
            Currency<span class="text-danger"> *</span>
            <v-select
              id="currency"
              v-model="adAccountInfo.currency"
              :options="currencyOptions"
              :reduce="(option) => option.value"
              label="text"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-card>

      <b-button
        class="mr-50 mt-50 float-right"
        variant="primary"
        @click="success"
      >
        Done
      </b-button>
      <b-button
        class="mr-1 mt-50 float-right"
        variant="outline-secondary"
        @click="cancel"
      >
        Cancel
      </b-button>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import AdAccountService from "@/services/ad-account.service";

export default {
  name: "UpdateAdAccountModal",
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    vSelect,

    ValidationProvider,
    ValidationObserver,
  },
  props: {
    adAccount: {
      type: Object,
      default: {},
    },
    refreshData: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      adAccountInfo: { ...this.adAccount },

      titleSize: 50,
      descriptionSize: 200,

      timezoneOptions: [
        {
          value: "Seoul",
          text: "Asia/Seoul (UTC +09:00)",
        },
      ],
      currencyOptions: [
        {
          value: "KRW",
          text: "KRW",
        },
        {
          value: "USD",
          text: "USD",
        },
      ],
    };
  },
  methods: {
    refreshAdAccountInfo(adaccount){
      this.adAccountInfo = adaccount;
    },
    checkInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.checkInfoRules.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    cancel() {
      this.$bvModal.hide("update-ad-account-modal");
    },
    async success() {
      await this.checkInfo();
      this.$swal({
        title: "Are you sure?",
        text: `You want to update the ad account!`,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await AdAccountService.update(this.adAccountInfo);
          if (response && response.status === 200) {
            this.$bvModal.hide("update-ad-account-modal");
            this.refreshData();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `Successfully updated!`,
                icon: "EditIcon",
                variant: "success",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || "Unknown error",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          }
        }
      });
    },
  },
  mounted() {
    this.$root.$on("refresh-adaccountinfo", (adaccount) => {
      this.refreshAdAccountInfo(adaccount);
    });
  },
};
</script>
